import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {DocumentActions} from "../actions";
import {catchError, map, mergeMap} from "rxjs";
import {ApiError} from "@esa/api";
import {ApiErrorHandlerService} from "../../services";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../environments/environment";

@Injectable()
export class DocumentsEffects {

  downloadDocument$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DocumentActions.downloadDocument),
      mergeMap((action) => this.httpClient.get(environment.apiUrl + '/api/document/download/' + action.id,{ responseType: 'blob' }).pipe(
        map(document => DocumentActions.downloadDocumentSuccess({ document: { content: document, fileName: action.fileName } })),
        catchError((error: ApiError) => {
          return this.apiErrorHandlerService.handleError(error, DocumentActions.downloadDocumentError());
        })
      ))
    );
  });

  constructor(
    private actions$: Actions,
    private apiErrorHandlerService: ApiErrorHandlerService,
    private httpClient: HttpClient
  ) {}
}
